/** The `itemActions` area: the item act menu, and the state and health chips.
 *  Owned by the stage 2 slot components-a (docs/I18N.md §11). */
export const itemActions = {
  // The cascade-close confirm.
  'itemActions.cascade.justThis': 'Just this one',
  /** The close-all button's title: the titles of the ancestors that close too. */
  'itemActions.cascade.alsoFinishes': 'Also finishes: {titles}',
  'itemActions.cascade.closeAll': { one: 'Finish all {count}', other: 'Finish all {count}' },
  'itemActions.cancel': 'Cancel',
  // The review composer (accept or deny, with a note and follow-ups).
  'itemActions.review.notePlaceholder': 'Optional comment…',
  'itemActions.review.noteLabel': 'Acceptance note',
  'itemActions.review.followUpPlaceholder': 'Follow-up (tech debt, rework, circle back on…)',
  'itemActions.review.followUpTitle': 'Follow-up {n} title',
  'itemActions.review.followUpDuePlaceholder': 'Due (2026-09-30, 2026-W40)',
  'itemActions.review.followUpDue': 'Follow-up {n} due',
  'itemActions.review.removeFollowUp': 'Remove follow-up {n}',
  'itemActions.review.addFollowUp': '+ Follow-up',
  'itemActions.review.accept': 'Accept',
  'itemActions.review.deny': 'Deny',
  'itemActions.review.outOfRole': 'out of role',
  'itemActions.review.flagCritical': 'Out of role (self-dealing) - logged as critical.',
  'itemActions.review.flagWarning': 'Out of role - this will be logged as a warning.',
  // The stage word's move menu.
  'itemActions.stage.menu': 'Move to stage',
  'itemActions.stage.trigger': 'Stage: {word}. Move "{title}" to another stage',
  'itemActions.stage.applies': 'applies {means}',
  'itemActions.stage.loading': 'Loading…',
  'itemActions.stage.loadFailed': 'Could not load the stages. Close and retry.',
  /** The state chips' words (domain/state-chips.ts): the activity, then the
   *  item's position (docs/CLOSED_AXIS.md, the four positions). The verdict's
   *  two words are `item.state.verdict.*`. */
  'itemActions.stateChip.active': 'Active',
  'itemActions.stateChip.idle': 'Idle',
  'itemActions.stateChip.review': 'Review',
  'itemActions.stateChip.done': 'Done',
  'itemActions.stateChip.cancelled': 'Cancelled',
} as const;
